class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
    this.bindUpsellButton();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink) return;

    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  bindUpsellButton() {
    this.addEventListener("click", (event) => {
      const upsellButton = event.target.closest(".upsell-add-button");
      if (upsellButton) {
        event.preventDefault();

        const form = upsellButton.closest(".upsell-form");
        const variantId = form.querySelector('input[name="id"]').value;
        // VM fix (Oct 2026): carry the selling plan when the upsell form has one
        const planField = form.querySelector('[name="selling_plan"]');
        const sellingPlanId = planField && planField.value ? planField.value : null;

        this.addItemToCart(variantId, sellingPlanId);
      }
    });
  }

  // VM fix (Oct 2026): accept a selling plan and surface errors to the shopper.
  // Before this change the request sent only {id, quantity}. Plan-only products
  // (the 90-day bundles) answered 422 and the shopper saw nothing happen.
  async addItemToCart(variantId, sellingPlanId = null) {
    const sections = this.getSectionsToRender().map((section) => section.id);

    const payload = {
      id: variantId,
      quantity: 1,
      sections: sections,
      sections_url: window.location.pathname,
    };
    if (sellingPlanId) payload.selling_plan = sellingPlanId;
    const body = JSON.stringify(payload);

    try {
      const response = await fetch(`${routes.cart_add_url}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: `application/json`,
        },
        body,
      });

      if (response.status === 422) {
        const errorData = await response.json();
        console.error("Error adding item to cart:", errorData.description);
        this.showAddError(errorData.description || errorData.message);
        return;
      }

      if (!response.ok) {
        console.error("Error adding item to cart: HTTP", response.status);
        this.showAddError();
        return;
      }

      const parsedState = await response.json();
      this.renderContents(parsedState);
    } catch (error) {
      console.error("Error adding item to cart:", error);
      this.showAddError();
    }
  }

  // VM fix (Oct 2026): visible, non-blocking error message
  showAddError(message) {
    const text =
      message ||
      "Sorry, we couldn't add that to your cart. Please try again.";
    let toast = document.getElementById("vm-cart-add-error");
    if (!toast) {
      toast = document.createElement("div");
      toast.id = "vm-cart-add-error";
      toast.setAttribute("role", "alert");
      toast.style.cssText =
        "position:fixed;left:50%;bottom:90px;transform:translateX(-50%);max-width:90vw;background:#b3261e;color:#fff;padding:12px 16px;border-radius:8px;font-size:14px;line-height:1.4;z-index:99999;box-shadow:0 4px 16px rgba(0,0,0,.25);text-align:center;";
      document.body.appendChild(toast);
    }
    toast.textContent = text;
    clearTimeout(this._vmErrorTimer);
    this._vmErrorTimer = setTimeout(() => toast.remove(), 6000);
  }

  startCountdownTimer() {
    const timerElement = document.getElementById("cart-countdown-timer");
    if (!timerElement) return;

    // Reset timer to 10 minutes
    let minutes = 10;
    let seconds = 0;

    // Clear any existing timer
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }

    // Update the timer display
    const updateTimer = () => {
      timerElement.textContent = `${minutes
        .toString()
        .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    };

    // Initial display
    updateTimer();

    // Start the countdown
    this.countdownInterval = setInterval(() => {
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(this.countdownInterval);
          return;
        }
        minutes--;
        seconds = 59;
      } else {
        seconds--;
      }

      updateTimer();
    }, 1000);
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");

    $(".gbfrequently-bought-with-main-whole-slider").slick({
      infinite: true,
      autoplaySpeed: 1000,
      autoplay: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
    });
    $(".gbfrequently-bought-with-main-whole-slider").css("opacity", "1");

    // Start the countdown timer when drawer opens
    this.startCountdownTimer();
  }

  close() {
    // Check if cart customization mode is active
    const cartCustomizationMode = document
      .querySelector("cart-drawer")
      .classList.contains("customization-mode");
    if (cartCustomizationMode) {
      alert(
        "Cart Customization Mode is active. Disable it in Theme Settings > Cart Drawer to allow closing."
      );
      return;
    }

    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");

    // Clear the countdown timer when drawer closes
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      if (section.id == "cart-drawer" || section.selector == "#CartDrawer") {
        const newCartDrawer = this.getSectionDOM(
          parsedState.sections[section.id],
          section.selector
        );
        updateCartDrawer(sectionElement, newCartDrawer);
      } else {
        sectionElement.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });

    $(".gbfrequently-bought-with-main-whole-slider").slick({
      infinite: true,
      autoplaySpeed: 1000,
      autoplay: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
    });
    $(".gbfrequently-bought-with-main-whole-slider").css("opacity", "1");
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    setTimeout(function () {
      var $slider = $(".gbfrequently-bought-with-main-whole-slider");
      if ($slider.length > 0 && !$slider.hasClass("slick-initialized")) {
        $slider.slick({
          infinite: true,
          autoplaySpeed: 1000,
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          // adaptiveHeight: true
          //prevArrow: $('.our-customer-slider-prev'),
          //nextArrow: $('.our-customer-slider-next'),
        });
        $slider.css("opacity", "1");
      }
    }, 500);

    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    setTimeout(function () {
      $(".gbfrequently-bought-with-main-whole-slider").slick({
        infinite: true,
        autoplaySpeed: 1000,
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
      });
      $(".gbfrequently-bought-with-main-whole-slider").css("opacity", "1");
    }, 500);

    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);

/* =====================================================================
   VM fix 1 (Oct 2026): repair over-encoded discount buy links
   Bundle buy buttons link to /discount/CODE?redirect=<target>. When the
   target nests /cart/clear?return_to=... or carries percent-encoded
   characters, Shopify's /discount redirect re-encodes it and the shopper
   lands on a 404. A working link has a fully plain target, encoded once:
     /discount/CODE?redirect=%2Fcart%2Fadd%3Fitems...%26return_to%3D%2Fcheckout
   This rewrites every such link on the page, including links that live in
   product descriptions, and swaps each one for a clean copy so handlers
   bound to the broken version (inline add scripts, BOGOS) do not run
   twice on top of the working redirect.
   ===================================================================== */
(function () {
  function fullyDecode(s) {
    for (var i = 0; i < 6; i++) {
      var d;
      try { d = decodeURIComponent(s); } catch (e) { return s; }
      if (d === s) return s;
      s = d;
    }
    return s;
  }

  function analyze(href) {
    if (!href || href.indexOf("/discount/") === -1) return null;
    var u;
    try { u = new URL(href, window.location.origin); } catch (e) { return null; }
    if (u.origin !== window.location.origin) return null;
    if (u.pathname.indexOf("/discount/") !== 0) return null;
    var redirect = u.searchParams.get("redirect");
    if (!redirect) return null;

    var target = fullyDecode(redirect).trim();
    var clearFirst = false;
    var m = target.match(/^\/cart\/clear\?return_to=(.+)$/i);
    if (m) { clearFirst = true; target = m[1]; }
    if (!/^\/cart\/add\?/i.test(target)) return null;

    var needsFix = clearFirst || /%[0-9A-Fa-f]{2}/.test(redirect);
    if (!needsFix) return null;

    // Put return_to first. BOGOS binds its checkout handler to any
    // a[href$='checkout'], and that handler re-fires the click, which
    // double-adds on buttons that also carry an inline add script.
    var q = target.slice(target.indexOf("?") + 1).split("&");
    var rt = [], rest = [];
    for (var i = 0; i < q.length; i++) (q[i].indexOf("return_to=") === 0 ? rt : rest).push(q[i]);
    target = "/cart/add?" + rt.concat(rest).join("&");

    return { fixed: u.pathname + "?redirect=" + encodeURIComponent(target) };
  }

  function repairOne(a) {
    if (a.dataset.vmLinkFixed) return a;
    var r = analyze(a.getAttribute("href"));
    if (!r) return a;
    // Swap in a clean copy: the href alone does the whole job now, and the
    // copy carries none of the handlers that were bound to the broken link.
    var clean = a.cloneNode(true);
    clean.setAttribute("href", r.fixed);
    clean.removeAttribute("sca_handle_checkout");
    clean.dataset.vmLinkFixed = "1";
    if (a.parentNode) a.parentNode.replaceChild(clean, a);
    return clean;
  }
  window.vmRepairDiscountLink = repairOne;

  function repairAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope !== document && scope.matches && scope.matches('a[href*="/discount/"]')) repairOne(scope);
    var links = scope.querySelectorAll('a[href*="/discount/"]');
    for (var i = 0; i < links.length; i++) repairOne(links[i]);
  }

  function start() {
    repairAll(document);
    if (window.MutationObserver) {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            if (added[j].nodeType === 1) repairAll(added[j]);
          }
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
/* =====================================================================
   VM fix 2 (Oct 2026): sticky "Start Now" bar
   sections/sticky-add-to-cart.liquid defines an inline addToCartSticky()
   that posts only {id, quantity}. That ignores the purchase option the
   shopper selected on the page (AutoShip) and fails silently with a 422
   on plan-only products (the 90-day bundles). This replaces it:
     1. If the page has a discount buy link for this variant (bundle pages),
        follow it, so checkout shows the promised price.
     2. Otherwise add the item with the product's Recharge subscription plan
        (AutoShip & Save, $65.99 on the tinctures). The plan comes from the
        page's product form when it has one selected, else from the product's
        own selling-plan data. Products with no plan add as one-time.
   This file is deferred, so it runs after the inline script and wins.
   ===================================================================== */
(function () {
  function pageSelectedPlan(variantId) {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var form = forms[i];
      if (form.closest("#CartDrawer, cart-drawer, #stickyAddToCart, .upsell-form")) continue;
      var idInput = form.querySelector('input[name="id"]');
      if (!idInput || String(idInput.value) !== String(variantId)) continue;
      var planField = form.querySelector('[name="selling_plan"]');
      if (planField && planField.value) return planField.value;
    }
    return null;
  }

  function findDiscountBuyLink(variantId) {
    var links = document.querySelectorAll('a[href*="/discount/"]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute("href") || "";
      var decoded = href;
      for (var k = 0; k < 6; k++) {
        var d;
        try { d = decodeURIComponent(decoded); } catch (e) { break; }
        if (d === decoded) break;
        decoded = d;
      }
      if (decoded.indexOf("/cart/add") !== -1 && decoded.indexOf(String(variantId)) !== -1) return links[i];
    }
    return null;
  }

  function subscriptionPlanId(variantId) {
    var selected = pageSelectedPlan(variantId);
    if (selected) return Promise.resolve(selected);
    var match = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!match) return Promise.resolve(null);
    return fetch("/products/" + match[1] + ".js", { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants) return null;
        var variant = null;
        for (var i = 0; i < p.variants.length; i++) {
          if (String(p.variants[i].id) === String(variantId)) { variant = p.variants[i]; break; }
        }
        if (!variant) variant = p.variants[0];
        var allocations = (variant && variant.selling_plan_allocations) || [];
        if (allocations.length) return allocations[0].selling_plan_id;
        var group = (p.selling_plan_groups || [])[0];
        var plan = group && group.selling_plans && group.selling_plans[0];
        return plan ? plan.id : null;
      })
      .catch(function () { return null; });
  }

  function stickyAddToCart() {
    var variantInput = document.getElementById("sticky-variant-id");
    var cartDrawer = document.querySelector("cart-drawer");
    if (!variantInput || !cartDrawer) return;
    var variantId = variantInput.value;
    if (!variantId) return;

    // Bundle pages: the price on the page depends on a discount link
    // (/discount/CODE?redirect=/cart/add?...). Route the sticky button
    // through that link so checkout shows the promised price.
    var buyLink = findDiscountBuyLink(variantId);
    if (buyLink) {
      if (window.vmRepairDiscountLink) buyLink = window.vmRepairDiscountLink(buyLink);
      window.location.assign(buyLink.getAttribute("href"));
      return;
    }

    // Regular products: always the Recharge subscription plan when one exists.
    subscriptionPlanId(variantId).then(function (planId) {
      cartDrawer.addItemToCart(variantId, planId);
    });
  }

  function install() { window.addToCartSticky = stickyAddToCart; }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", install);
  } else {
    install();
  }
})();

